import React from 'react';
import {reportClientError} from '@common/errors/client-error-reporter';

interface RootErrorBoundaryState {
  failed: boolean;
}

export class RootErrorBoundary extends React.Component<
  React.PropsWithChildren,
  RootErrorBoundaryState
> {
  state: RootErrorBoundaryState = {failed: false};

  static getDerivedStateFromError(): RootErrorBoundaryState {
    return {failed: true};
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportClientError(error, {
      componentStack: info.componentStack || undefined,
    });
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="max-w-600 mx-auto flex min-h-screen flex-col items-center justify-center px-24 text-center">
          <h1 className="text-2xl">Something went wrong</h1>
          <p className="mt-12 text-muted">
            We encountered an unexpected error. Reload the page to try again.
          </p>
          <button
            type="button"
            className="mt-24 rounded-button bg-primary px-20 py-10 text-on-primary"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
